import { Col, Layout, Row } from 'antd';
import type React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import styles from './AntdLayout.module.css';
import { Footer, Header, ScrollToTop, Sidebar, TestButton } from './components';

const App: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const customise = useSelector((state: any) => state.customise);

  return (
    <Layout className={styles.layout}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>
        <Header setCollapsed={setCollapsed} />
        <Layout.Content className={styles.contentMain}>
          <Row justify="center">
            {customise.contentWidth === 'full' && (
              <Col xxl={17} xl={22} span={24}>
                <Outlet />
              </Col>
            )}

            {customise.contentWidth === 'boxed' && (
              <Col className="hp-w-100" style={{ maxWidth: 936 }}>
                <Outlet />
              </Col>
            )}
          </Row>
        </Layout.Content>
        <TestButton />
        <Footer />
      </Layout>
      <ScrollToTop />
    </Layout>
  );
};

export default App;
